// Quick-action button below the composer — clicking inserts a canned prompt into the textarea.
import type { LucideIcon } from 'lucide-react';
import { chatStore } from '@/lib/chatStore';

export function QuickAction({
  icon: Icon,
  label,
  textareaRef,
}: {
  icon: LucideIcon;
  label: string;
  textareaRef: React.RefObject<HTMLTextAreaElement | null>;
}) {
  return (
    <button
      type="button"
      onClick={() => {
        chatStore.setInput(label);
        textareaRef.current?.focus();
      }}
      className="flex items-center gap-1.5 rounded-lg border border-border bg-card px-3 py-1.5 text-xs text-muted-foreground transition-colors hover:border-primary/30 hover:bg-accent hover:text-foreground"
    >
      <Icon className="h-3 w-3" aria-hidden="true" />
      {label}
    </button>
  );
}
